import React, { Component } from 'react';
import { Jumbotron, Container, Row, Col, Form, Button, Table } from 'react-bootstrap';
import Menu from '../../menu';
import funciones from '../../../middleware/funciones';
import SearchClient from '../../subcomponent/searchClient';
import config from '../../../config';
import { CSVLink } from "react-csv";

export class reporteCartera extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        //const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        this.state = {
            empresa: currentCompany,
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            clientes: [],
            infoReporte: [],
            cliente: ""
        };
    }

    componentDidMount = () => {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/clients/', datasend).then(response => response.json())
            .then(data => this.setState({ clientes: data }));
    }

    selectClient = (client) => {
        const { DOCUMENTO_CLIENTE } = client;
        this.setState({ cliente: DOCUMENTO_CLIENTE })
    }

    updateReport = () => {
        const estado = '0' ;
        const busqueda = {
            cliente: this.state.cliente,
            fecha_ini: this.state.fecha_inicial,
            fecha_fin: this.state.fecha_final,
            estado
        }
        const datasend = {
            method: 'POST',
            body: JSON.stringify(busqueda),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        };

        fetch(config.servBackEnd + '/invoice/searchInvoice', datasend).then(response => response.json())
            .then(datos => {
                const { data } = datos
                ////console.log(datos);
                if (datos.ok) {
                    this.setState({ infoReporte: data })
                } else {
                    this.setState({ infoReporte: [] })
                }
            });
    }

    render() {
        const {infoReporte} = this.state;
        let totalPendiente = 0;
        return (
            <div className="contenedor">
                <Menu></Menu>
                <Jumbotron className="Jumbotron">
                    <h1>Reporte Cartera</h1>
                </Jumbotron>
                <Container fluid>
                    <Row className="justify-content-md-center" >
                        <Col className="mb-2" xs={5} lg={1}>CLIENTE</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <SearchClient data={this.state.clientes} event={this.selectClient}></SearchClient>
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={funciones.formatDate(this.state.fecha_inicial)} />
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={funciones.formatDate(this.state.fecha_final)} />
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center" >
                        <Col className="mb-2" xs={12} lg={2}>
                        <CSVLink data={infoReporte} filename={"REPORTE_CARTERA.csv"} separator={";"}>
                                <Button disabled={infoReporte.length === 0} variant="success">Descargar Reporte</Button>
                            </CSVLink>
                        </Col>
                        <Col className="mb-2" xs={12} lg={2}>
                            <Button id="actualizar" name="actualizar" onClick={this.updateReport}>Generar Reporte</Button>
                        </Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Table>
                        <thead>
                            <tr>
                                <th>DOCUMENTO CLIENTE</th>
                                <th>NOMBRE CLIENTE</th>
                                <th>FECHA DOCUMENTO</th>
                                <th>FECHA VENCIMIENTO</th>
                                <th>DIAS VENCIMIENTO</th>
                                <th>DOCUMENTO</th>
                                <th>TOTAL DOCUMENTO</th>
                                <th>TOTAL ABONADO</th>
                                <th>PENDIENTE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {infoReporte.map((element,i)=>{
                                totalPendiente += (parseFloat(element.TOTAL_VENTA) - parseFloat(element.TOTAL_ABONADO));
                                return(
                                    <tr key={i}>
                                        <td>{element.DOCUMENTO_CLIENTE}</td>
                                        <td>{element.NOMBRE_CLIENTE}</td>
                                        <td>{element.FECHA_DOCUMENTO}</td>
                                        <td>{element.FECHA_VENCIMIENTO_DOCUMENTO}</td>
                                        <td>{element.DIAS_VENCIMIENTO}</td>
                                        <td>{element.TIPO_DOCUMENTO_CABECERA+"-"+element.NUMERO_FACTURA_CABECERA}</td>
                                        <td className="currSign">{ Intl.NumberFormat('es-MX').format(element.TOTAL_VENTA)}</td>
                                        <td className="currSign">{ Intl.NumberFormat('es-MX').format(element.TOTAL_ABONADO)}</td>
                                        <td className="currSign">{ Intl.NumberFormat('es-MX').format(parseFloat(element.TOTAL_VENTA) - parseFloat(element.TOTAL_ABONADO))}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan="5"></th>
                                <th colSpan="2">TOTAL PENDIENTE</th>
                                <th colSpan="2"  className="currSign">{Intl.NumberFormat('es-MX').format(totalPendiente)}</th>
                            </tr>
                        </tfoot>
                    </Table>
                </Container>
            </div>
        )
    }
}

export default reporteCartera
